// eslint-disable-next-line no-restricted-imports
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import useLocaleContext from '../../hooks/useLocaleContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LocaleFormattedJSXMessage({
  message,
  options,
  elements
}) {
  const {
    locale
  } = useLocaleContext();
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: message,
    options: Object.assign({
      locale
    }, options),
    elements: elements
  });
}